import { VFC, useMemo } from 'react';
import { PHASES, Phase } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface PhaseSelectProps {
  value?: Phase;
  onChange?: (value: Phase) => void;
}

export const PhasesSelect: VFC<PhaseSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const phasesOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(PHASES),
        suggestedValue: meterModelSuggestions?.phases?.value,
        suggestedSelection: meterModelSuggestions?.phases?.selection,
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={phasesOptions}
      placeholder={<FormattedMessage {...messages.numberOfPhasesPlaceholder} />}
      {...restProps}
    />
  );
};
